import styles from "./WalletButton.module.css";
import React, {useContext, useEffect, useState} from "react";
import {WalletContext} from "../../store/WalletContext";
import Web3Modal from "web3modal";
import {ethers} from "ethers";

const WalletButton = (props) => {
    const [isConnecting, setIsConnecting] = useState(false);
    const {currentAccount, setCurrentAccount} = useContext(WalletContext);

    const connectWallet = async () => {
        setIsConnecting(true);

        const providerOptions = {};

        const web3Modal = new Web3Modal({
            network: "mainnet",
            cacheProvider: true,
            providerOptions
        });

        const provider = await web3Modal.connect();
        const ethersProvider = new ethers.providers.Web3Provider(provider);
        const address = await ethersProvider.getSigner().getAddress();

        setIsConnecting(false);
        setCurrentAccount(address);
    }

    const disconnectWallet = async () => {
        try {
            const {ethereum} = window;

            if (!ethereum) {
                alert("Get MetaMask!");
                return;
            }

            // TODO: clear window.ethereum cache - this solution is not working
            await window.ethereum.request({
                method: "eth_requestAccounts",
                params: [{eth_accounts: {}}]
            });
            setCurrentAccount("");
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        setCurrentAccount();
    }, []);

    //TODO: two components - connect and disconnect
    // return <>{!currentAccount ? <Guest/> : <Main/>}</>;

    return (
        <div className={styles.navigation_wrapper}>
            <div className={styles.nav_account_wrapper}>
                <div className={styles.nav_account_actions}>
                    {!currentAccount ?
                        <>
                            <div className={styles.button_wrapper}>
                                <button className={styles.account_button} onClick={connectWallet}>
                                    Connect wallet
                                </button>
                            </div>
                        </>
                        :
                        <>
                            <div className={styles.account_text}>
                                {currentAccount.slice(0, 6) + "..." + currentAccount.slice(38, 42)}
                            </div>
                            <div className={styles.button_wrapper}>
                                <button className={styles.account_button} onClick={disconnectWallet}>
                                    Disconnect wallet
                                </button>
                            </div>
                        </>
                    }
                </div>
            </div>
        </div>
    )
        ;

    // TODO: figure out Yi's code style to imitate
    // return (
    //     <button onClick={props.onClick} className={styles.button}>
    //         {props.children}
    //     </button>
    // );
};

export default WalletButton;
